import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import { Field, FieldDescription, FieldLabel } from '@/components/ui/field'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { cn } from '@/lib/utils'
import { format } from 'date-fns'
import { CalendarIcon, X } from 'lucide-react'
import { type DateRange } from 'react-day-picker'

interface DatePickerWithRangeProps {
  value?: DateRange
  onChange: (value: DateRange | undefined) => void
  onClear?: () => void
  label?: string
  placeholder?: string
  description?: string
  className?: string
}

export function DatePickerWithRange({
  value,
  onChange,
  onClear,
  label = 'Período',
  placeholder = 'Selecione um intervalo',
  description,
  className,
}: DatePickerWithRangeProps) {
  return (
    <Field className={cn('w-full md:w-[320px]', className)}>
      <FieldLabel htmlFor='date-picker-range'>{label}</FieldLabel>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant='outline'
            id='date-picker-range'
            className='justify-start px-2.5 text-left font-normal'
          >
            <CalendarIcon className='mr-2 h-4 w-4 shrink-0' />
            {value?.from ? (
              value.to ? (
                <>
                  {format(value.from, 'dd/MM/yyyy')} - {format(value.to, 'dd/MM/yyyy')}
                </>
              ) : (
                format(value.from, 'dd/MM/yyyy')
              )
            ) : (
              <span>{placeholder}</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className='w-auto p-0' align='start'>
          <Calendar
            mode='range'
            defaultMonth={value?.from}
            selected={value}
            onSelect={onChange}
            numberOfMonths={2}
          />
          {onClear && value?.from && (
            <div className='border-t p-3'>
              <Button type='button' variant='ghost' size='sm' onClick={onClear}>
                <X className='mr-2 h-4 w-4' />
                Limpar filtro
              </Button>
            </div>
          )}
        </PopoverContent>
      </Popover>
      {description && <FieldDescription>{description}</FieldDescription>}
    </Field>
  )
}
